import { store } from '@/state/store';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';

export function FN_GRID2D_CELL__try_set_image(cell: DTO__grid2d_cell) {
  let { hash_sha256_content } = cell;

  if (hash_sha256_content.is_empty_hash_sha256()) return;

  let { images_map } = store.getState().slice_images;

  if (!images_map.has(hash_sha256_content)) return;

  let image = images_map.get_or_assert(hash_sha256_content);

  cell.image = image.clone();
}
